import { render } from "./PaymentCompleteOld.vue?vue&type=template&id=5e794d6c&scoped=true"
import script from "./PaymentCompleteOld.vue?vue&type=script&lang=js"
export * from "./PaymentCompleteOld.vue?vue&type=script&lang=js"

import "./PaymentCompleteOld.vue?vue&type=style&index=0&id=5e794d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e794d6c"]])

export default __exports__